import ApiService from "../../../../ApiService";

const ReviewService = {
    loadScreenView: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/management/review/loadscreenview", { searchVO }, successCallback, failureCallback);
    },
    saveComments: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/management/review/savecomments", vo, successCallback, failureCallback);
    },
    uploadAudio: (file, uploadPath, partnerId, successCallback, failureCallback) => {
        let formData = new FormData();
        formData.append("fileData", file);
        formData.append("uploadPath", uploadPath);
        formData.append("partnerId", partnerId);
        ApiService.postFileToServer("/web/admin/homework/management/review/uploadaudio", formData, successCallback, failureCallback);
    },
    deleteFile: (virtualPath, partnerId, userHomeworkUnitId, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/management/review/deletefile", { partnerId, virtualPath, userHomeworkUnitId }, successCallback, failureCallback);
    },
    saveAiScore: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/management/review/saveaiscore", vo, successCallback, failureCallback);
    },
    makeUnitScreenshot: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/management/review/makeunitscreenshot", vo, successCallback, failureCallback);
    },
    getAiHelp: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/management/review/getaihelp", vo, successCallback, failureCallback);
    },
    getAiHelpByTask: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/management/review/getaihelpbytask", vo, successCallback, failureCallback);
    },
    getTaskProgress: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/management/review/gettaskprogress", { id }, successCallback, failureCallback);
    },
};

export default ReviewService;
